import { register } from '../../core/bootstrapper';
import CartView from './cartView';

register('cart', () => {

    new CartView({
        el: $('#cart-main')
    });

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/cart/cartBootstrap.js
 **/